export default "__VITE_ASSET__nW3Pprxr__"